import { REGEX } from './../../../shared/utils/regex';
import * as Yup from "yup";

export const containerActivityValidationSchema = Yup.object().shape({
    activityType: Yup.string()
        .required('Activity Type is required!'),
    activityDate: Yup.string()
        .required('Activity Date is required!'),
})
